<template>
  <div>
    <h6 style="color: #101010;line-height: 31px;">
      {{ $l('form_header_role') || '角色信息' }}
    </h6>
    <el-form size="small" label-width="80px" label-position="left">
      <el-row :gutter="20">
        <el-col :span="14">
          <el-form-item :label="$l('form_label_roleName') || '角色名称'">
            {{ formData.roleName }}
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item :label="$l('form_label_isUseDataRange') || '分类权限'">
            {{
              formData.isUseDataRange === 'N'
                ? $l('form_label_isUseDataRange_N') || '不启用'
                : $l('form_label_isUseDataRange_Y') || '启用'
            }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$l('form_label_createByName') || '创建人'">
            {{ formData.createByName }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$l('form_label_createDate') || '创建时间'">
            {{ formData.createDate }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$l('form_label_modifyByName') || '修改人'">
            {{ formData.modifyByName }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$l('form_label_modifyDate') || '修改时间'">
            {{ formData.modifyDate }}
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <UserList class="mt-4" :roleID="roleID" />
  </div>
</template>

<script>
import UserList from './user-list'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: { UserList },
  mixins: [EditLoading],
  props: { roleID: { type: String, default: '' } },
  data() {
    return { formData: {} }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.roleID) return
      const res = await this.$api
        .sysRoleDetailApi({ roleID: this.roleID })
        .catch(() => null)
      this.formData = res?.body || {}
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-form {
    border-top: 1px solid #ebeef5;
    border-right: 1px solid #ebeef5;
    .el-form-item {
      margin: 0 !important;
      .el-form-item__label {
        color: #909399;
        background: #fafafa;
        text-align: left;
        font-weight: 400;
        line-height: 1.5;
        padding: 8px 10px;
        border-left: 1px solid #ebeef5;
        border-right: 1px solid #ebeef5;
        font-size: 12px !important;
      }
      .el-form-item__content {
        padding: 0 10px;
        box-sizing: border-box;
        font-weight: 400;
        color: #606266;
        font-size: 12px !important;
        display: flex;
        align-items: center;
        line-height: 34px;
      }
    }
    .el-row {
      margin: 0 !important;
    }
    .el-col {
      padding: 0 !important;
      border-bottom: 1px solid #ebeef5;
    }
  }
}
</style>
